import { i18n } from './globalize';

const required = value => (value || value == '0') ? undefined : i18n.t('Validator_Required');

const requiredArray = value => (value && value.length > 0) ? undefined : i18n.t('Validator_Required');

const minLength = min => value =>
	value && value.length < min ? i18n.t('Validator_MinLength', { min }) : undefined;

const maxLength = max => value =>
	value && value.length > max ? i18n.t('Validator_MaxLength', { max }) : undefined;

const number = value => value && isNaN(Number(value)) ? i18n.t('Validator_Number') : undefined;

const integer = value => value && (Number(value) !== parseInt(value, 10)) ? i18n.t('Validator_Integer') : undefined;

const minValue = min => value =>
	value && value < min ? i18n.t('Validator_MinValue', { min }) : undefined;

const maxValue = max => value =>
	value && value > max ? i18n.t('Validator_MaxValue', { max }) : undefined;

const range = (min, max) => value =>
	value && (value < min || value > max) ? i18n.t('Validator_Range', { min, max }) : undefined;

const pattern = (regex, messageI18nKey) => value =>
	value && !regex.test(value) ?
		i18n.t(messageI18nKey || 'Validator_Pattern') : undefined;

const email = pattern(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, 'Validator_Email');

const dateInThePast = value => value && (value instanceof Date) && value > new Date() ? i18n.t('Validator_DateInThePast') : undefined;

// The escapes inside the character classes are redundant but harmless. Left verbatim
// rather than edited to silence a style rule - this validates user-entered URLs and is
// not worth the risk of a subtle change.
// eslint-disable-next-line no-useless-escape
const url = pattern(/^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/i, 'Validator_Url');

export default {
	required,
	requiredArray,
	minLength,
	maxLength,
	number,
	integer,
	minValue,
	maxValue,
	range,
	pattern,
	email,
	dateInThePast,
	url
};
